if (!customElements.get('leo-card-cta')) {
  class LeoCardCta extends HTMLElement {
    connectedCallback() {
      if (this.__initialized) return;
      this.__initialized = true;

      var cta = this;
      var productCard = cta.closest('product-card, .product-card');
      var radios = cta.querySelectorAll('input[type="radio"][data-variant-id]');
      var variantInput = cta.querySelector('.leo-card-form__variant-id');
      var form = cta.querySelector('.leo-card-form');
      var btnLabel = cta.querySelector('.leo-card-add-btn__label');
      var btn = cta.querySelector('.leo-card-add-btn');
      var soldOutText = cta.dataset.soldOutText || 'Sold out';
      var addText = cta.dataset.addText || 'Add to cart';

      if (productCard) {
        var qa = productCard.querySelector('quick-add-component');
        if (qa && qa.parentNode) {
          qa.parentNode.removeChild(qa);
        }

        var gallery = productCard.querySelector('.card-gallery');
        var galleryLink = productCard.querySelector('a[ref="cardGalleryLink"], a[href*="/products/"]');
        if (gallery && galleryLink && !gallery.__leoClickBound) {
          gallery.__leoClickBound = true;
          var productUrl = galleryLink.getAttribute('href');
          gallery.style.cursor = 'pointer';
          gallery.addEventListener('click', function (e) {
            if (e.target.closest('.leo-card-cta, button, input, label, slideshow-controls, .slideshow-controls')) {
              return;
            }
            e.preventDefault();
            e.stopPropagation();
            window.location.href = productUrl;
          }, true);
        }
      }

      function updateCardImage(imageUrl, imageAlt) {
        if (!productCard || !imageUrl) return;
        var gallery = productCard.querySelector('.card-gallery');
        if (!gallery) return;
        var firstImg = gallery.querySelector('img');
        if (!firstImg) return;
        if (firstImg.src === imageUrl) return;
        firstImg.src = imageUrl;
        if (firstImg.srcset) firstImg.srcset = '';
        if (imageAlt) firstImg.alt = imageAlt;
        var picture = firstImg.closest('picture');
        if (picture) {
          picture.querySelectorAll('source').forEach(function (s) {
            s.srcset = imageUrl;
          });
        }
      }

      function updateCardPrice(price, comparePrice) {
        if (!productCard || !price) return;
        var priceEl = productCard.querySelector('product-price, .price, price-list');
        if (!priceEl) return;
        var regularSpan = priceEl.querySelector('.price');
        var compareSpan = priceEl.querySelector('.compare-at-price');
        if (regularSpan) regularSpan.textContent = price;
        if (compareSpan) {
          if (comparePrice) {
            compareSpan.textContent = comparePrice;
            compareSpan.style.display = '';
            if (compareSpan.parentElement && compareSpan.parentElement.getAttribute('role') === 'group') {
              compareSpan.parentElement.style.display = '';
            }
          } else {
            compareSpan.textContent = '';
            if (compareSpan.parentElement && compareSpan.parentElement.getAttribute('role') === 'group') {
              compareSpan.parentElement.style.display = 'none';
            } else {
              compareSpan.style.display = 'none';
            }
          }
        }
      }

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          variantInput.value = r.dataset.variantId;
          var available = r.dataset.available === 'true';
          btn.disabled = !available;
          btnLabel.textContent = available ? addText : soldOutText;
          updateCardImage(r.dataset.imageUrl, r.dataset.imageAlt);
          updateCardPrice(r.dataset.price, r.dataset.comparePrice);
        });
      });

      cta.querySelectorAll('.leo-card-variant').forEach(function (label) {
        label.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
      }, true);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (btn.disabled) return;

        var cartItems = document.querySelector('cart-items-component[data-section-id]');
        var headerSectionId = cartItems ? cartItems.getAttribute('data-section-id') : null;

        var body = new FormData(form);
        if (headerSectionId) {
          body.append('sections', headerSectionId);
          body.append('sections_url', '/');
        }

        btn.disabled = true;
        var original = btnLabel.textContent;
        btnLabel.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              btnLabel.textContent = original;
              btn.disabled = false;
              return;
            }

            if (res.sections && headerSectionId && res.sections[headerSectionId]) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(res.sections[headerSectionId], 'text/html');

              var newCartItems = doc.querySelector('cart-items-component');
              var currentCartItems = document.querySelector('cart-items-component');
              if (newCartItems && currentCartItems) {
                currentCartItems.innerHTML = newCartItems.innerHTML;
                if (typeof currentCartItems.updatedCallback === 'function') {
                  currentCartItems.updatedCallback();
                }
              }

              var newDrawer = doc.querySelector('cart-drawer-component');
              var currentDrawer = document.querySelector('cart-drawer-component');
              if (newDrawer && currentDrawer) {
                var newHeader = newDrawer.querySelector('.cart-drawer__header');
                var currentHeader = currentDrawer.querySelector('.cart-drawer__header');
                if (newHeader && currentHeader) currentHeader.innerHTML = newHeader.innerHTML;

                var newSummary = newDrawer.querySelector('.cart-drawer__summary');
                var currentSummary = currentDrawer.querySelector('.cart-drawer__summary');
                if (newSummary && currentSummary) currentSummary.innerHTML = newSummary.innerHTML;
              }

              var newBubble = doc.querySelector('cart-bubble, .cart-bubble, [ref="cartBubble"]');
              var currentBubble = document.querySelector('cart-bubble, .cart-bubble, [ref="cartBubble"]');
              if (newBubble && currentBubble) {
                currentBubble.outerHTML = newBubble.outerHTML;
              }
            }

            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            var drawer = document.querySelector('cart-drawer-component');
            if (drawer) {
              if (typeof drawer.open === 'function') {
                drawer.open();
              } else if (typeof drawer.showDialog === 'function') {
                drawer.showDialog();
              }
            }

            btnLabel.textContent = 'Added';
            setTimeout(function () {
              btnLabel.textContent = original;
              btn.disabled = false;
            }, 1500);
          })
          .catch(function () {
            btnLabel.textContent = original;
            btn.disabled = false;
          });
      });
    }
  }

  customElements.define('leo-card-cta', LeoCardCta);
}